export default __webpack_public_path__ + "media/landscape/logo_netflix-6460862c.svg";